import React from 'react'
import { Image } from '@/components/ui'
import { useWebpExtension } from '@/utils/hooks/image'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { FundingBannerLogos } from '../FundingBannerLogos'
import { FUNDING_BANNER_INFO_ITEMS } from './constants'
import { FundingBannerInfoItem } from './FundingBannerInfoItem'
import { messages } from './messages'
import './styles.scss'

export const FundingBannerInfo = () => {
  const imageExtension = useWebpExtension()
  const { isDesktop } = useDeviceType()

  return (
    <div className="fundingBannerInfo">
      <div className="fundingBannerInfo__image">
        <Image src={`index/about/funding-banner.${imageExtension}`} isInStatic width={389} height={432} loading="eager" />
      </div>

      <div className="fundingBannerInfo__text">
        <h3 className="fundingBannerInfo__title">{messages.title}</h3>

        {FUNDING_BANNER_INFO_ITEMS.length > 0 && (
          <div className="fundingBannerInfo__items">
            {FUNDING_BANNER_INFO_ITEMS.map(bannerInfoItem => (
              <FundingBannerInfoItem key={bannerInfoItem.text} options={bannerInfoItem} />
            ))}
          </div>
        )}

        {isDesktop && <FundingBannerLogos />}
      </div>
    </div>
  )
}
